import { render, staticRenderFns } from "./EditManagerStatus.component.vue?vue&type=template&id=508d07e6"
import script from "./EditManagerStatus.component.vue?vue&type=script&lang=ts"
export * from "./EditManagerStatus.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports